import clsx from 'clsx';
import { ReactElement } from 'react';
import { useFeatureFlags } from '@provider-directory/contexts/FlagContext';
import LanguageSelector from '../language-selector/language-selector.component';

export const LanguageSelectorFull = ({
  className,
}: {
  className?: string;
}): ReactElement => {
  const { featureFlags } = useFeatureFlags();

  if (!featureFlags.isLocalizationEnabled) {
    return <></>;
  }

  return (
    <div
      className={clsx(
        'flex w-full flex-row justify-end bg-[--header-color] px-6 py-2 print:hidden',
        className,
      )}
    >
      <LanguageSelector buttonClassName={'text-white'} />
    </div>
  );
};
